import React from 'react';
import { useAuth } from '../context/AuthContext';
import {
  Box,
  Typography,
  Paper,
  Alert,
  Chip,
  Divider
} from '@mui/material';

/**
 * Página de depuración para verificar autenticación y roles
 */
const DebugAuth = () => {
  const { currentUser, userData, loading } = useAuth();

  if (loading) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography>Cargando información de autenticación...</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Depuración de Autenticación
      </Typography>
      
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          Estado de Autenticación
        </Typography>
        
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" color="text.secondary">
            Estado de carga: {loading ? 'Cargando...' : 'Completado'}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Usuario autenticado: {currentUser ? 'Sí' : 'No'}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Datos de usuario disponibles: {userData ? 'Sí' : 'No'}
          </Typography>
        </Box>
      </Paper>

      {currentUser && (
        <Paper sx={{ p: 3, mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            Firebase Auth User (currentUser)
          </Typography>
          
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2">
              <strong>UID:</strong> {currentUser.uid}
            </Typography>
            <Typography variant="body2">
              <strong>Email:</strong> {currentUser.email}
            </Typography>
            <Typography variant="body2">
              <strong>Email verificado:</strong> {currentUser.emailVerified ? 'Sí' : 'No'}
            </Typography>
            <Typography variant="body2">
              <strong>Fecha de creación:</strong> {currentUser.metadata?.creationTime}
            </Typography>
            <Typography variant="body2">
              <strong>Último inicio:</strong> {currentUser.metadata?.lastSignInTime}
            </Typography>
          </Box>
        </Paper>
      )}

      {userData && (
        <Paper sx={{ p: 3, mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            Firestore User Data (userData)
          </Typography>
          
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2">
              <strong>Rol:</strong> <Chip label={userData.role} color="primary" size="small" />
            </Typography>
            <Typography variant="body2">
              <strong>Email:</strong> {userData.email}
            </Typography>
            <Typography variant="body2">
              <strong>Nombre:</strong> {userData.name || 'No definido'}
            </Typography>
            <Typography variant="body2">
              <strong>ID de convenio:</strong> {userData.convenioId || 'No aplica'}
            </Typography>
            <Typography variant="body2">
              <strong>Nombre de convenio:</strong> {userData.convenioName || 'No aplica'}
            </Typography>
            <Typography variant="body2">
              <strong>Fecha de creación:</strong> {userData.createdAt?.toDate?.() || 'No disponible'}
            </Typography>
          </Box>
          
          <Divider sx={{ my: 2 }} />
          
          <Typography variant="h6" gutterBottom>
            Objeto completo userData:
          </Typography>
          
          <Box sx={{ bgcolor: 'grey.100', p: 2, borderRadius: 1 }}>
            <pre style={{ margin: 0, fontSize: '12px', overflow: 'auto' }}>
              {JSON.stringify(userData, null, 2)}
            </pre>
          </Box>
        </Paper>
      )}

      {!currentUser && !loading && (
        <Alert severity="warning">
          No hay ningún usuario autenticado. Por favor inicia sesión.
        </Alert>
      )}

      {currentUser && !userData && (
        <Alert severity="error">
          El usuario está autenticado pero no se encontraron datos en Firestore. 
          Esto puede indicar que el documento del usuario no fue creado correctamente.
        </Alert>
      )}

      {userData && userData.role === 'user' && (
        <Alert severity="info">
          El usuario tiene rol "user". Debería poder acceder a Dashboard, Solicitudes, Agenda, Cirugías, Hospital y Pacientes.
        </Alert>
      )}
    </Box>
  );
};

export default DebugAuth;
